import React from "react";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";

import Grid from "@material-ui/core/Grid";

import {
  VERIFICATION_OK,
  VERIFICATION_WARNING,
  VERIFICATION_THREAT,
} from "../../../constants/eventGroups";

import images from "../../../assets/img/images";

const styles = {
  confirmationIcon: {
    width: "30px",
  },
};

const Instructions = (props) => {
  const { classes, surveyStatus, lukeActionId /*profileName */ } = props;

  return (
    <>
      <Grid item style={{ padding: "12px", maxWidth: "400px" }}>
        <Grid container direction="column">
          <Grid
            item
            className="text-center"
            style={{ margin: "20px 0px 10px" }}
          >
            {[VERIFICATION_WARNING, VERIFICATION_THREAT].includes(
              surveyStatus
            ) || lukeActionId === 89 ? (
              <img
                src={images.medicalRedCross}
                className={classes.confirmationIcon}
                alt="medical_red_cross"
              />
            ) : (
              <img
                src={images.greenCheckmark}
                className={classes.confirmationIcon}
                alt="green_checkmark"
              />
            )}
          </Grid>
          <Grid
            item
            className="text-87"
            style={{ marginTop: "20px", textAlign: "left" }}
          >
            <span>{`${I18n.get("profiles_covidMsg1")} ${I18n.get(
              "profiles_covidMsg2"
            )}`}</span>
            {/* <span>{I18n.get("profiles_covidMsg1")}</span>
            <span>{` ${profileName} `}</span>
            <span>{I18n.get("profiles_covidMsg2")}</span> */}
          </Grid>
          <Grid
            item
            className="text-87"
            style={{ margin: "20px 0px 30px", textAlign: "left" }}
          >
            {[VERIFICATION_WARNING, VERIFICATION_THREAT].includes(
              surveyStatus
            ) || lukeActionId === 89
              ? I18n.get("profiles_covidMsgWarning")
              : I18n.get("profiles_covidMsgClear")}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

Instructions.propTypes = {
  surveyStatus: PropTypes.oneOf([
    VERIFICATION_OK,
    VERIFICATION_WARNING,
    VERIFICATION_THREAT,
  ]).isRequired,
  profileName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(Instructions));
